// Share the same import promise between background loading and React.lazy.
// A failed request is removed so the next navigation can retry.
const cached = <T,>(load: () => Promise<T>) => {
  let pending: Promise<T> | undefined;
  return () => {
    if (!pending) {
      pending = load().catch((error: unknown) => {
        pending = undefined;
        throw error;
      });
    }
    return pending;
  };
};

export const adminPageModules = {
  dashboard: cached(() => import('../pages/admin/AdminDashboard')),
  notifications: cached(() => import('../pages/admin/AdminNotifications')),
  shipping: cached(() => import('../pages/admin/AdminShipping')),
  videos: cached(() => import('../pages/admin/AdminVideos')),
  orders: cached(() => import('../pages/admin/AdminOrders')),
  orderDetails: cached(() => import('../pages/admin/AdminOrderDetails')),
  products: cached(() => import('../pages/admin/AdminProducts')),
  inventory: cached(() => import('../pages/admin/AdminInventory')),
  followups: cached(() => import('../pages/admin/AdminFollowups')),
  gemfinderPayments: cached(() => import('../pages/admin/AdminGemFinderPayments')),
  bestsellers: cached(() => import('../pages/admin/AdminBestsellers')),
  blogs: cached(() => import('../pages/admin/AdminBlogs')),
  banners: cached(() => import('../pages/admin/AdminBanners')),
  reviews: cached(() => import('../pages/admin/AdminReviews')),
  coupons: cached(() => import('../pages/admin/AdminCoupons')),
  offers: cached(() => import('../pages/admin/AdminOffers')),
  braceletGift: cached(() => import('../pages/admin/AdminBraceletGift')),
  recentPurchases: cached(() => import('../pages/admin/AdminRecentPurchases')),
  gemfinder: cached(() => import('../pages/admin/AdminGemfinder')),
  appPromotion: cached(() => import('../pages/admin/AdminAppPromotion')),
  access: cached(() => import('../pages/admin/AdminAccess')),
};

export const adminModuleForPath: Record<string, () => Promise<unknown>> = {
  '/admin/dashboard': adminPageModules.dashboard,
  '/admin/notifications': adminPageModules.notifications,
  '/admin/shipping': adminPageModules.shipping,
  '/admin/videos': adminPageModules.videos,
  '/admin/orders': adminPageModules.orders,
  '/admin/products': adminPageModules.products,
  '/admin/inventory': adminPageModules.inventory,
  '/admin/followups': adminPageModules.followups,
  '/admin/orders/pending-payments': adminPageModules.followups,
  '/admin/gemfinder/pending-payments': adminPageModules.followups,
  '/admin/gemfinder/payments': adminPageModules.gemfinderPayments,
  '/admin/bestsellers': adminPageModules.bestsellers,
  '/admin/blogs': adminPageModules.blogs,
  '/admin/banners': adminPageModules.banners,
  '/admin/reviews': adminPageModules.reviews,
  '/admin/coupons': adminPageModules.coupons,
  '/admin/offers': adminPageModules.offers,
  '/admin/bracelet-gift': adminPageModules.braceletGift,
  '/admin/recent-purchases': adminPageModules.recentPurchases,
  '/admin/gemfinder': adminPageModules.gemfinder,
  '/admin/app-promotion': adminPageModules.appPromotion,
  '/admin/access': adminPageModules.access,
};
